import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import FishermanIcon from '../../../Icon/Icon';
export function getPaginationIndicatorProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onlyPageIndicators = _ref.onlyPageIndicators,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    activePage = _ref.activePage,
    totalPages = _ref.totalPages,
    disableIndicatorsOnLimit = _ref.disableIndicatorsOnLimit,
    _ref$directionIndicat = _ref.directionIndicatorIcons,
    directionIndicatorIcons = _ref$directionIndicat === void 0 ? {} : _ref$directionIndicat;
  var onFirstPage = _isNumber(activePage) && activePage === 1;
  var onLastPage = _isNumber(activePage) && activePage === totalPages;
  var paginationProps = {};
  if (!_isEmpty(pageIndicatorIcon)) {
    paginationProps = _objectSpread(_objectSpread({}, paginationProps), {}, {
      pageItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: pageIndicatorIcon
        }),
        icon: true
      }
    });
  }
  if (onlyPageIndicators) {
    paginationProps = _objectSpread(_objectSpread({}, paginationProps), {}, {
      boundaryRange: 3,
      ellipsisItem: null,
      firstItem: null,
      lastItem: null,
      nextItem: null,
      prevItem: null,
      siblingRange: 2
    });
  } else {
    paginationProps = _objectSpread(_objectSpread({}, paginationProps), {}, {
      firstItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'firstItem', 'angle double left')
        }),
        icon: true
      },
      lastItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'lastItem', 'angle double right')
        }),
        icon: true
      },
      prevItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'prevItem', 'angle left'),
          disabled: disableIndicatorsOnLimit && onFirstPage
        }),
        icon: true
      },
      nextItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'nextItem', 'angle right'),
          disabled: disableIndicatorsOnLimit && onLastPage
        }),
        icon: true
      }
    });
  }
  return paginationProps;
}